import React from "react";
import { useNavigate } from "react-router-dom";
import ROUTE_PATHS from "../../../utils/routePaths";
import TripCard from "../../ListOfTripRequest/views/TripCard";

const ListOfHistoricTrip = ({ trips, currentPage }) => {
  const navigate = useNavigate();

  const handleTripClick = (tripId) => {
    navigate(ROUTE_PATHS.HISTORIC_TRIP_DETAILS(tripId), { state: { currentPage } });
  };

  return (
    <div>
      <div className="trip-request-list">
        {trips?.map((trip) => {
          const requiresOvertime =
            trip?.requiresArrivalOvertime ||
            trip?.requiresDepartureOvertime ||
            false;

          return (
            <TripCard
              key={trip?.id}
              tripData={trip}
              afterHoursStatus={requiresOvertime}
              onClick={() => handleTripClick(trip?.id)}
              isHistoric={true}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ListOfHistoricTrip;
